import React, { useState, useEffect, ReactNode } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Backdrop from '@mui/material/Backdrop';

interface LoaderProps {
  loading: boolean;
  children?: React.ReactNode; 
}

interface LoaderHook {
  loading: boolean;
  showLoading: () => void;
  hideLoading: () => void;
  LoaderComponent: React.FC<LoaderProps>;
}

const useLoader = (): LoaderHook => {
  const [loading, setLoading] = useState(false);

  const showLoading = () => {
    setLoading(true);
  };

  const hideLoading = () => {
    setLoading(false);
  };

  const LoaderComponent: React.FC<LoaderProps> = ({ children }) => (
    <div>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      {children}
    </div>
  );

  return { loading, showLoading, hideLoading, LoaderComponent };
};

export default useLoader;
